import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'master', 'checkbox' ]

  toggle() {
    const checked = this.masterTarget.checked

    this.checkboxTargets.forEach(element => {
      element.checked = checked
    })
  }
}
